import React, { useEffect, useState } from 'react';
import Cookies from 'universal-cookie';
import { useNavigate } from 'react-router-dom';
import LoginMobileForm from '../../components/forms/login/LoginMobileForm';
import RequestService from '../../services/RequestService';
import VerifyForm from '../../components/forms/verify/VerifyForm';

type ActiveForm = 'login' | 'verify';

const Login = () => {
  const navigate = useNavigate();
  const cookies = new Cookies(null, { path: '/' });

  const storedCode = sessionStorage.getItem('verificationCode');
  const storedExpiresAt = sessionStorage.getItem('verificationExpiresAt');

  const initialExpiresAt = storedExpiresAt ? Number(storedExpiresAt) : null;

  const hasValidVerification =
    Boolean(storedCode) &&
    initialExpiresAt !== null &&
    initialExpiresAt > Date.now();

  const [code, setCode] = useState(storedCode ?? '');

  const [form, setForm] = useState<ActiveForm>(
    hasValidVerification ? 'verify' : 'login'
  );

  const [expiresAt, setExpiresAt] = useState<number | null>(
    hasValidVerification ? initialExpiresAt : null
  );

  const [isSubmitting, setIsSubmitting] = useState(false);

  const onLoginSubmit = async (data: any) => {
    setIsSubmitting(true);
    const requestService = new RequestService('/api/v1/auth/login');
    const result = await requestService.post(data);
    if (result.status === 'OK') {
      const expiryInSeconds = Number(result.data.expiry);
      const expirationTime = Date.now() + expiryInSeconds * 1000;

      sessionStorage.setItem('verificationCode', result.data.code);
      sessionStorage.setItem(
        'verificationExpiresAt',
        expirationTime.toString()
      );

      setExpiresAt(expirationTime);
      setCode(result.data.code);
      setForm('verify');
    }
    setIsSubmitting(false);
  };

  const onVerifySubmit = async (data: any) => {
    const payload = { ...data, code };
    setIsSubmitting(true);
    const requestService = new RequestService('/api/v1/auth/verify');
    const result = await requestService.post(payload);
    if (result.status === 'OK') {
      sessionStorage.removeItem('verificationCode');
      sessionStorage.removeItem('verificationExpiresAt');

      cookies.set('token', result.data.token);
      cookies.set('user_id', result.data.user.id);
      cookies.set('role_name', result.data.role.name);
      cookies.set('role_label', result.data.role.label);

      navigate('/main');
    }
    setIsSubmitting(false);
  };

  const handleVerificationExpire = () => {
    sessionStorage.removeItem('verificationCode');
    sessionStorage.removeItem('verificationExpiresAt');

    setCode('');
    setExpiresAt(null);
    setForm('login');
  };

  useEffect(() => {
    if (!hasValidVerification) {
      sessionStorage.removeItem('verificationCode');
      sessionStorage.removeItem('verificationExpiresAt');
    }
  }, [hasValidVerification]);

  return (
    <div className="text-white w-96 my-40 mx-auto p-16 pt-5 bg-white rounded-md">
      {form === 'login' ? (
        <LoginMobileForm
          onSubmit={onLoginSubmit}
          isSubmitting={isSubmitting}
          formTitle="ورود"
          buttonTitle="دریافت کد"
        />
      ) : expiresAt ? (
        <VerifyForm
          onSubmit={onVerifySubmit}
          onExpire={handleVerificationExpire}
          expiresAt={expiresAt}
          isSubmitting={isSubmitting}
          formTitle="کد تایید"
          buttonTitle="تایید"
        />
      ) : null}
    </div>
  );
};

export default Login;
